import React, { useState, useEffect, useCallback } from 'react';
import { API_ADDRESS, PAGE_TITLE_BASE } from './constants.js';
import { useNavigate } from "react-router";

import { Dimmer, Loader, Segment, Card, CardContent, CardHeader } from 'semantic-ui-react'

export function Acts(props) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [acts, setActs] = useState([]);
  const [total, setTotal] = useState(0);

  document.title = 'Acts | ' + PAGE_TITLE_BASE;

  const search = useCallback(() => {  
    var url = `${API_ADDRESS}/acts`;

    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        setActs(json);
        setTotal(json.length);
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, []); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  const onClickHandler = (e, link) => {
    if(e.ctrlKey || e.metaKey){
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  }

  return (
    <div>
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
        <h1>Acts</h1>
        <p>Below are the names of the {total} acts in our database. Click the Card to view details</p>
        {acts.length === 0 && 
          <Card color='orange' style={{width:'100%'}}>
            <CardContent>
              <CardHeader>No acts found</CardHeader>
            </CardContent>
          </Card>
        }
        <div className="Cards">
          {acts.map(function(act, i) {
            let color = 'orange';
            if(i % 7 === 1) { color = 'teal'; }
            if(i % 7 === 2) { color = 'purple'; }
            if(i % 7 === 3) { color = 'green'; }
            if(i % 7 === 4) { color = 'yellow'; }
            if(i % 7 === 5) { color = 'red'; }
            if(i % 7 === 6) { color = 'pink'; }

            return <Card key={act.act_id}
              color={color}
              style={{width: '290px'}}
              onClick={(e) => onClickHandler(e, '/act/' + act.act_id)}
            >
              <CardContent>
                <CardHeader>{act.name}</CardHeader>
              </CardContent>
            </Card>
          })}
        </div>
      </Segment>
    </div>
  );
}